import React, {useEffect, useState} from 'react'
import ErrorComponent from '../../components/error';
import {connect} from 'react-redux';
import {AppUrls, ErrorRoutes} from '../../constants';
import {updateError} from '../../actions';
import {useHistory} from 'react-router';
import {useTranslation} from 'react-i18next';
import {config} from "../../config";

const ErrorManager = (props: any) => {
  const [state, setState] = useState({
    title: '',
    description: '',
    showRefreshButton: true,
    showAtlasAuthButton: false,
    contactAdmin: true,
  });
  const history = useHistory()
  const {t} = useTranslation();

  useEffect((): void => {
    const pathname = history.location.pathname
    if (pathname === ErrorRoutes.NOT_FOUND) {
      setState({
        description: '',
        title: t("not_found_title"),
        showRefreshButton: true,
        contactAdmin: true,
        showAtlasAuthButton: false,
      });
    } else if (pathname === ErrorRoutes.ACCESS_DENIED) {
      setState({
        description: '',
        title: t("access_denied_title"),
        showRefreshButton: true,
        contactAdmin: true,
        showAtlasAuthButton: false,
      });
    } else if (pathname === ErrorRoutes.UNAUTHORIZED) {
      setState({
        description: t("access_unauthorized", {publikAuthUrl: config.publikAuthUrl}),
        title: t("access_unauthorized_title"),
        showRefreshButton: true,
        contactAdmin: false,
        showAtlasAuthButton: true,
      });
    } else if (pathname === ErrorRoutes.SSO_ERROR) {
      setState({
        description: t("access_sso_error"),
        title: t("access_sso_error_title"),
        showRefreshButton: false,
        contactAdmin: true,
        showAtlasAuthButton: false,
      });
    } else if (pathname === ErrorRoutes.EXPIRED) {
      setState({
        description: t("expired_error"),
        title: t("expired_error_title"),
        showRefreshButton: false,
        contactAdmin: false,
        showAtlasAuthButton: false,
      });
    } else {
      setState({
        description: '',
        title: t("oups_title"),
        showRefreshButton: true,
        contactAdmin: true,
        showAtlasAuthButton: false,
      });
    }
  }, [history.location.pathname, t]);

  const refreshPage = (): void => {
    props.updateError({isError: false, message: '', status: null});
    window.location.href = AppUrls.HOME;
  }

  const navigateToAuthentication = (): void => {
    window.location = config.apiUrl + '/saml/login' as any;
  }

  return (
    <ErrorComponent
      title={state.title}
      description={state.description}
      refreshPage={refreshPage}
      navigateToAuthentication={navigateToAuthentication}
      showRefreshButton={state.showRefreshButton}
      contactAdmin={state.contactAdmin}
      showAtlasAuthButton={state.showAtlasAuthButton}
    />
  );
}
const mapStateToProps = (state: any) => ({
  error: state.error
});

const mapDispatchToProps = {
  updateError
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorManager);